export default {
  Prefix: "",
  Source: "User",
  FrDate: new Date(),
  ToDate: new Date(),
  InvhTInvNo: "",
  InvhTInvDt: null,
  InvhDesc: "",
  VnName: "",
  TaxProfileCode: "NONE",
  BfTaxAmt: 0,
  TaxRate: 0,
  TaxAmt: 0,
  TotalAmt: 0,
  TaxId: "",
  BranchNo: "",
  Address: "",
  UserModified: localStorage.getItem("UserName"),
};
